// extracted by mini-css-extract-plugin
export default {"root":"MobileColumn1_root__+jkp2","top":"MobileColumn1_top__NTsF4","bottom":"MobileColumn1_bottom__h9Krl"};